import createReducer from "../createReducer";
import { ILayoutState } from "./types";
import { layoutHandlers } from "./handlers";

export const LayoutInitialState: ILayoutState = {
    list: {},
    edited: 0,
};

export default createReducer(LayoutInitialState, layoutHandlers);
